<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 16.226"
    aria-hidden="true"
  >
    <path
      id="Path_28"
      data-name="Path 28"
      d="M20.525,239.548q0-.4-.611-.4H7.376a2.316,2.316,0,0,0-.985.248,2.382,2.382,0,0,0-.824.605l-3.388,4.183a.841.841,0,0,0-.207.461q0,.4.611.4H15.12a2.632,2.632,0,0,0,1.809-.864L20.317,240a.753.753,0,0,0,.207-.449ZM7.376,237.67h8.851v-1.844a1.1,1.1,0,0,0-1.106-1.106H8.482a1.1,1.1,0,0,1-1.106-1.106v-.738a1.1,1.1,0,0,0-1.106-1.106H2.581a1.1,1.1,0,0,0-1.106,1.106v9.83l2.95-3.63a3.886,3.886,0,0,1,1.337-1.008,3.722,3.722,0,0,1,1.613-.4ZM22,239.548a2.2,2.2,0,0,1-.53,1.383l-3.4,4.183a3.745,3.745,0,0,1-1.337,1.008,3.774,3.774,0,0,1-1.613.4H2.581a2.484,2.484,0,0,1-1.821-.761A2.484,2.484,0,0,1,0,243.939V232.876a2.484,2.484,0,0,1,.761-1.821,2.484,2.484,0,0,1,1.821-.761H6.269a2.484,2.484,0,0,1,1.821.761,2.484,2.484,0,0,1,.761,1.821v.369H15.12a2.6,2.6,0,0,1,2.581,2.581v1.844h2.213a2.347,2.347,0,0,1,1.141.282,1.776,1.776,0,0,1,.772.812A1.824,1.824,0,0,1,22,239.548Z"
      transform="translate(0 -230.294)"
      fill="currentColor"
    />
  </svg>
</template>
